import { render, staticRenderFns } from "./reisen-metadata-card-flugdaten.vue?vue&type=template&id=10038922&scoped=true"
import script from "./reisen-metadata-card-flugdaten.vue?vue&type=script&lang=js"
export * from "./reisen-metadata-card-flugdaten.vue?vue&type=script&lang=js"
import style0 from "./reisen-metadata-card-flugdaten.vue?vue&type=style&index=0&id=10038922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10038922",
  null
  
)

export default component.exports